<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="grid-container fluid">
      <div
        v-if="informationFirst"
        data-test="information-first"
        class="grid-x grid-margin-x"
      >
        <div
          class="cell"
          v-html="informationFirst"
        />
      </div>
      <div class="grid-margin-x boss-bgcolor-white-gray padding-top-1">
        <div class="cell pega-notice-header">
          <img
            class="pega-icon-bell"
            src="@/assets/images/bell.png"
          >
          <span>お知らせ</span>
        </div>
        <section class="cell">
          <div
            v-if="isSelectionConfirmation"
            data-test="selection-confirmation"
            class="pega-notice-label pega-input"
            @click="onClick('phases_and_statuses', goSettingsSelection)"
          >
            （ご利用の前に）御社の[選考フェーズ・選考ステータス]をご確認ください。
          </div>
          <div
            v-if="isBeforePublishedConfirmation"
            data-test="before-published-confirmation"
            class="pega-notice-label pega-input"
            @click="onClick('before_publishing_checklist', goCheckList)"
          >
            （ご利用の前に）掲載前チェックリストをご確認ください
          </div>
          <div
            v-if="newEntryCount"
            data-test="new-entry-count"
            class="pega-notice-label pega-input"
            @click="onClick('', goEntryTop)"
          >
            新しい応募が{{ newEntryCount }}件あります。
          </div>
          <div
            v-if="showNewMessageCount"
            data-test="new-message-count"
            class="pega-notice-label pega-input"
            @click="onClick('', goEntryTop)"
          >
            新しいメッセージが届きました。{{ newMessageCountText }}
          </div>
          <div
            v-if="isSearchNewUsers"
            data-test="search-new-users"
            class="pega-notice-label pega-input"
            @click="onClick('updated_user_resume', goScoutTop)"
          >
            保存した検索条件に、新しい会員がヒットしました。スカウトを送ってみませんか
          </div>
          <div
            v-if="isRecommendedNewUsers"
            data-test="recommended-new-users"
            class="pega-notice-label pega-input hover"
            @click="onClick('new_recommended_users', goScoutTop)"
          >
            おすすめ会員が更新されました。スカウトを送ってみませんか
          </div>
          <div
            v-if="isInterviewCandidateDateConfirmation"
            data-test="interview-candidate-date-confirmation"
            class="pega-notice-label pega-input"
            @click="onClick('new_publishing_interview_candidate_date', goInterviewCandidateDateTop)"
          >
            一次面接候補日の設定が必要な方は、ご確認ください。
          </div>
        </section>
        <informations
          v-if="!!informations.length"
          :informations="informations"
        />
      </div>
      <div
        v-if="showScout"
        class="grid-x grid-margin-x"
      >
        <div class="width-100">
          <section class="boss-pickup-container">
            <scout-recommended-members />
          </section>
        </div>
      </div>
      <div
        v-if="informationThird"
        data-test="information-third"
        class="grid-x grid-margin-x margin-top-1"
      >
        <div
          class="cell"
          v-html="informationThird"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ScoutRecommendedMembers from '@/components/organisms/ScoutRecommendedMembers'
import Informations from '@/components/molecules/Informations.vue'

export default {
  components: {
    Informations,
    ScoutRecommendedMembers
  },
  data () {
    return {
      isSelectionConfirmation: false,
      isBeforePublishedConfirmation: false,
      newEntryCount: 0,
      newMessageCount: {
        selection: 0,
        entered: 0,
        ng: 0,
        decline: 0
      },
      isSearchNewUsers: false,
      isRecommendedNewUsers: false,
      isInterviewCandidateDateConfirmation: false,
      informationFirst: '',
      informationThird: '',
      informations: []
    }
  },
  computed: {
    ...mapGetters('contracts', {
      publishedContracts: 'publishedContracts'
    }),
    ...mapGetters([
      'showScout'
    ]),
    newMessageCountText () {
      return (this.newMessageCount.selection !== 0 ? ('（選考中の応募者から：' + this.newMessageCount.selection + '件）') : '') +
        (this.newMessageCount.entered !== 0 ? ('（入社の応募者から：' + this.newMessageCount.entered + '件）') : '') +
        (this.newMessageCount.ng !== 0 ? ('（NGの応募者から：' + this.newMessageCount.ng + '件）') : '') +
        (this.newMessageCount.decline !== 0 ? ('（辞退の応募者から：' + this.newMessageCount.decline + '件）') : '')
    },
    showNewMessageCount () {
      return this.newMessageCountText.length !== 0
    }
  },
  // ログイン済みの場合にダッシュボードに即遷移した時に権限が取得が終わっていない場合に契約と表示情報が取得されないパターンがある。
  // 権限が変更された時にwatchを行い、契約と表示情報を取得する。
  watch: {
    showScout (value) {
      if (value) {
        this.fetchContractsAndScoutDisplayItems()
      }
    }
  },
  created () {
    if (this.showScout) {
      this.fetchContractsAndScoutDisplayItems()
    }
    const confirmations = [
      { apiPath: 'phases_and_statuses', dataPath: 'isSelectionConfirmation' },
      { apiPath: 'before_publishing_checklist', dataPath: 'isBeforePublishedConfirmation' },
      { apiPath: 'new_entry_count', dataPath: 'newEntryCount' },
      { apiPath: 'new_entry_messages_count', dataPath: 'newMessageCount' },
      { apiPath: 'updated_user_resume', dataPath: 'isSearchNewUsers' },
      { apiPath: 'new_recommended_users', dataPath: 'isRecommendedNewUsers' },
      { apiPath: 'new_publishing_interview_candidate_date', dataPath: 'isInterviewCandidateDateConfirmation' }
    ]
    const contents = [
      { apiPath: 'bko_information_first', dataPath: 'informationFirst' },
      { apiPath: 'bko_information_third', dataPath: 'informationThird' }
    ]
    confirmations.forEach(
      confirmation => this.fetchUnconfirmedInformation(confirmation.apiPath, confirmation.dataPath))
    contents.forEach(content => this.fetchContentsInformation(content.apiPath, content.dataPath))
    this.fetchInformations()
  },
  methods: {
    ...mapActions('contracts', [
      'storeContracts'
    ]),
    ...mapActions('settings', [
      'storeScoutDisplayItems'
    ]),
    fetchUnconfirmedInformation (apiPath, dataPath) {
      this.$http.secured.get(`/company/unconfirmed_information/${apiPath}`).then((response) => {
        this.$set(this, dataPath, response.data)
      })
    },
    fetchContentsInformation (apiPath, dataPath) {
      this.$http.secured.get(`/company/contents/${apiPath}`).then((response) => {
        this.$set(this, dataPath, response.data)
      })
    },
    fetchInformations () {
      this.$http.secured.get('/company/informations').then((response) => {
        this.$set(this, 'informations', response.data)
      })
    },
    goScoutTop () {
      this.$router.push({ name: 'scoutTop' })
    },
    goEntryTop () {
      this.$router.push({ name: 'entryTop' })
    },
    goSettingsSelection () {
      this.$router.push({ name: 'settingSelections' })
    },
    goCheckList () {
      window.open('/help/guide/001.html', '_blank')
    },
    goInterviewCandidateDateTop () {
      this.$router.push({ name: 'interviewCandidateDateTop' })
    },
    onClick (apiPath, callback) {
      if (apiPath) {
        this.$http.secured.patch(`/company/unconfirmed_information/${apiPath}/_is_read`).then(() => {
          callback()
        })
      } else {
        callback()
      }
    },
    fetchContractsAndScoutDisplayItems () {
      this.storeContracts()
      this.storeScoutDisplayItems()
    }
  }
}
</script>
